module.exports = __webpack_public_path__ + "static/media/icon_framework.79037079.svg";